// extracted by mini-css-extract-plugin
export var blog_content = "suggestionBlogCard-module--blog_content--O9p0H";
export var blog_content_text = "suggestionBlogCard-module--blog_content_text--byzEY";
export var blog_date = "suggestionBlogCard-module--blog_date--Lnmxd";
export var blog_title = "suggestionBlogCard-module--blog_title--hjUQD";
export var card = "suggestionBlogCard-module--card--CdOf+";
export var category_tag = "suggestionBlogCard-module--category_tag--LB3cl";
export var category_text = "suggestionBlogCard-module--category_text--DB0D2";
export var content = "suggestionBlogCard-module--content--jzEVZ";
export var content_space = "suggestionBlogCard-module--content_space--yNHx2";
export var image = "suggestionBlogCard-module--image--Ur8+I";
export var image_link = "suggestionBlogCard-module--image_link--5ZBBB";
export var padding_zero = "suggestionBlogCard-module--padding_zero--g7ATp";